export enum AmplitudeEventType {
  AddOperatingManagerClicked = "AddOperatingManagerClicked",
  ApproveFileClicked = "ApproveFileClicked",
  ComplianceReportingPageViewed = "ComplianceReportingPageViewed",
  CyclePaymentSubmitClicked = "CyclePaymentSubmitClicked",
  CyclePaymentSuccess = "CyclePaymentSuccess",
  DirectDepositUpdatePageViewed = "DirectDepositUpdatePageViewed",
  DownloadTemplateClicked = "DownloadTemplateClicked",
  EnrollmentPageViewed = "EnrollmentPageViewed",
  FileUploadPageViewed = "FileUploadPageViewed",
  GrossEarningsPageViewed = "GrossEarningsPageViewed",
  HomePageViewed = "HomePageViewed",
  NetEarningsPageViewed = "NetEarningsPageViewed",
  OperatingManagerCreated = "OperatingManagerCreated",
  OtherReportingPageViewed = "OtherReportingPageViewed",
  PaydayExclusionsReportingPageViewed = "PaydayExclusionsReportingPageViewed",
  ReportExportClicked = "ReportExportClicked",
  RewardDownloadClicked = "RewardDownloadClicked",
  RewardReportPageViewed = "RewardReportPageViewed",
  RewardSetupPageViewed = "RewardSetupPageViewed",
  RejectFileClicked = "RejectFileClicked",
  UsagePageViewed = "UsagePageViewed",
  UserProfilePageViewed = "UserProfilePageViewed",
  UserRosterPageViewed = "UserRosterPageViewed",
  UsersPageViewed = "UsersPageViewed",
}
